import { createClient } from 'contentful';
export const configureContentfulBrowserClient = (config) => {
    return {
        contentfulClient: createClient({
            space: config.CONTENTFUL_SPACE,
            accessToken: config.CONTENTFUL_PUBLIC_TOKEN
        }),
        contentfulPreviewClient: createClient({
            space: config.CONTENTFUL_SPACE,
            accessToken: config.CONTENTFUL_PREVIEW_TOKEN,
            host: 'preview.contentful.com'
        })
    };
};
//# sourceMappingURL=contentful-browser.js.map